import { Component } from '@angular/core';
import { OpenOrderTableComponent } from 'gung-standard';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'car-liner-open-orders-table',
    templateUrl: './car-liner-open-orders-table.component.html',
    styleUrls: ['./car-liner-open-orders-table.component.scss'],
    standalone: false
})
export class CarLinerOpenOrdersTableComponent extends JeevesOpenOrderTableListComponent {
  getStatusTag(orderStatus: number): string {
    if (orderStatus < 13) {
      return 'ENTRY_IN_PROGRESS';
    } else if (orderStatus === 13) {
      return 'ENTERED';
    } else if (orderStatus >= 14 && orderStatus <= 50) {
      return 'PICKING_IN_PROGRESS';
    } else if (orderStatus === 70) {
      return 'INVOICED';
    }
    return 'UNDEFINED';
  }
}
